import React from 'react'
import { observer } from 'mobx-react'
import { teamStore } from '../../app/stores'
import BannedUser from './BannedUser'

const Banned = () => {
  return (
    <div className='Banned'>
      {teamStore.banList && Object.values(teamStore.banList).map(ban =>
        <BannedUser ban={ban} key={ban.ipAddress} />
      )}
    </div>
  )
}

Banned.displayName = 'Banned'

export default observer(Banned)



// WEBPACK FOOTER //
// ./src/dashboard/banned/Banned.js